/*
**  rui-record-detail-spacer.js
**
**  rui-record-detail-spacer component
*/
import { LitElement, html, css } from 'lit-element';
export class RuiRecordDetailSpacer extends LitElement {
    static get is() {
        return 'rui-record-detail-spacer';
    }
    static get properties() {
        return {};
    }
    constructor() {
        super();
    }
    render() {
        return html `
            <div class="rui-record-detail-spacer"></div>
        `;
    }
    static get styles() {
        return css `
            .rui-record-detail-spacer {
                height: 20px;
            }
        `;
    }
}
customElements.get(RuiRecordDetailSpacer.is) || customElements.define(RuiRecordDetailSpacer.is, RuiRecordDetailSpacer);
